export default {"src":"/_next/static/media/onyx-protocol.34c540b7.svg","height":354,"width":353,"blurWidth":0,"blurHeight":0};